<!-- MOSTRAR BOTONES -->
<div class="sticky-nav" *ngIf="(itemLock == null) || (bloqueado == false)">
    <mat-toolbar>
        <span>{{headerEntrada}}</span>
        <span class="spacer"></span>
        <div *ngIf="escritura">
            <button mat-stroked-button color="primary" class="!bg-white" type="button" (click)="crearEntradaHijo()" [disabled]="!deshabilitado">CREAR REGISTRO RELACIONADO</button>
            <button mat-stroked-button color="primary" class="!bg-white ml-1 mr-1" (click)="showAgenda()">CANCELAR</button>
            <button mat-flat-button color="primary" (click)="editar()" *ngIf="deshabilitado" [disabled]="deshabilitado_BtnEditar">EDITAR</button>
            <button mat-flat-button color="warn" appPreventDoubleClick (throttledClick)="guardar()" (click)="loading()" *ngIf="!deshabilitado" [disabled]="
                !formValid.entrada || 
                !formValid.asignacion_responsables || 
                (oEntrada.banEntregables && !formValid.entregables) ||
                !((oEntrada.banEntregables == true && oEntregables.length > 0) || (!oEntrada.banEntregables && oEntregables.length == 0)) ||
                !formValid.acuerdo
            ">GUARDAR</button>
        </div>
    </mat-toolbar>
</div>

<div *ngIf="bloqueado && itemLock" class="p-5 pt-0 pb-0">
    <mat-card appearance="outlined">
        <mat-card-content class="text-white bg-red-700">
            Esta entrada está siendo modificada, espere 5 minutos hasta que la edición esté terminada. <br>
            Editado por: {{itemLock.nombre}} <br>
            Hora del bloqueo : {{getDateFormat(itemLock.timestamp)}}
        </mat-card-content>
    </mat-card>
</div>

<div class="control hidden">
    itemLock: {{itemLock | json}} <br>
    lectura: {{lectura}} <br>
    escritura: {{escritura}} <br>
    bloqueado: {{bloqueado}} <br>
    desabilitado:  {{deshabilitado}} <br>
    -------------------------------------------------------------------------<br>
    entrada valid: {{formValid.entrada}} <br>
    asignacion_responsables valid: {{formValid.asignacion_responsables}} <br>
    acuerdo valid: {{formValid.acuerdo}} <br>
    entregables valid: {{formValid.entregables}} <br>
    responsables y entregables valid: {{((oEntrada.banEntregables == true && oEntregables.length > 0) || (!oEntrada.banEntregables && oEntregables.length == 0))}} <br>
</div>

<button  mat-button disabled color="primary" class="!absolute !right-0 !pt-3 !pr-5">
    @if(isExpired) {
        VENCIDO
    } @else {
        {{oEntrada.estatus_descripcion.toUpperCase()}}
    }
</button>

<mat-tab-group [(selectedIndex)]="MatTabIndex" mat-stretch-tabs="false" class="header" animationDuration="0ms">
    <mat-tab label="REGISTRO" color="primary">
        @if(isloadingCatalogos && isloadingEntrada && isloadingAcuerdo && isloadingUsuario) {
            <app-add-edit-entrada [listenToFather]="sendToChilds.asObservable()" (sendToFather)="listenToChilds($event)"></app-add-edit-entrada>
            <app-add-edit-archivos [listenToFather]="sendToChilds.asObservable()" (sendToFather)="listenToChilds($event)"></app-add-edit-archivos>
            <app-add-edit-asignacion-responsables [listenToFather]="sendToChilds.asObservable()" (sendToFather)="listenToChilds($event)"></app-add-edit-asignacion-responsables>
            <app-add-edit-envio-ab [listenToFather]="sendToChilds.asObservable()" (sendToFather)="listenToChilds($event)"></app-add-edit-envio-ab>
            <mat-toolbar>
                <span>Forma de Envío</span>
                <span class="spacer"></span>
            </mat-toolbar>
            <div class="p-5 bg-white w-full">
                <!-- [disabled]="(this.oAcuerdo.id_tipo_forma != 0 && this.oAcuerdo.id_tipo_forma != item.id && this.oAcuerdo.numeroEntradasTema == 1) -->
                <form [formGroup]="formAcuerdo">
                    <div class="flex p-5 pt-0 pb-0">
                        <mat-form-field class="w-1/2 mr-5">
                            <mat-label>Forma de envío</mat-label>
                            <mat-select formControlName="forma_envio">
                                @for (item of stateCatalogo.state().catalogos.catFormaEnvio; track item.id) {
                                    <mat-option [value]="item.id">{{item.descripcion}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <div class="w-1/2 mr-5"></div>
                    </div>
                    @if(isloadingMrB) {
                        <app-acuerdo-mrb [listenToFather]="sendToChilds.asObservable()" (sendToFather)="listenToChilds($event)"></app-acuerdo-mrb>
                    }

                    @if(isloadingDespacho) {
                        <app-despacho [listenToFather]="sendToChilds.asObservable()" (sendToFather)="listenToChilds($event)"></app-despacho>
                    }
                </form>
            </div>
            <app-add-edit-comentarios [listenToFather]="sendToChilds.asObservable()" (sendToFather)="listenToChilds($event)"></app-add-edit-comentarios>
            <app-add-edit-registros-relacionados [listenToFather]="sendToChilds.asObservable()" (sendToFather)="listenToChilds($event)"></app-add-edit-registros-relacionados>

            <div class="flex justify-end m-5 mr-10">
                <label class="ultima-modificacion">{{ultimaModificacion}}</label>
            </div>
        }
    </mat-tab>
    <mat-tab label="ENTREGABLES" [disabled]="(oEntrada.analista == '' || oEntrada.supervisor == '' || oEntrada.coordinador == '' || !oEntrada.banEntregables)">
        @if(isloadingCatalogos && isloadingEntrada && isloadingAcuerdo && isloadingUsuario) {
            <app-add-edit-entregable [listenToFather]="sendToChilds.asObservable()" (sendToFather)="listenToChilds($event)"></app-add-edit-entregable>
        }
    </mat-tab>
</mat-tab-group>